import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import { useDispatch, useSelector } from 'react-redux';
import { getErrorMessage } from '../utils';
import { login } from '../store/actions/auth';
import ForgotPasswordModal from '../components/ForgotPasswordModal';

const styles = {
  loginWrapper: {
    height: '100vh',
    width: '100vw',
    backgroundColor: 'dimgray',
    margin: 0,
  },
  cardWrapper: {
    width: '50%',
    boxSizing: 'border-box',
    padding: '5em',
    margin: 'auto',
    position: 'absolute',
    top: '15%',
    left: '25%',
  },
  loginButton: {
    marginTop: 16,
  },
  forgotButton: {
    marginTop: 16,
    marginRight: 16,
    textTransform: 'capitalize',
  },
  buttonRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: '8px',
  },
};

const Login = () => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const errors = useSelector((state) => state.auth.error);
  const [displayError, setDisplayError] = useState([]);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isForgotModalOpen, setForgotModalOpen] = useState(false);
  const history = useHistory();
  const sso = sessionStorage.getItem('sso');

  const handleSubmit = (event) => {
    event.preventDefault();
    dispatch(login({ username: username.toLowerCase(), password }));
  };

  useEffect(() => {
    if (sso && sso === 'true'){
      sessionStorage.removeItem('sso');
      history.push('/logout');
    }
  }, [sso]);

  useEffect(() => {
    if (token) {
      history.push(`/`);
    }
  }, [token]);

  useEffect(() => {
    if (errors) {
      setDisplayError(getErrorMessage(errors));
    }
  }, [errors]); 

  return (<div style={styles.loginWrapper}>
    <CssBaseline />
    <ForgotPasswordModal open={isForgotModalOpen} setOpen={setForgotModalOpen} />
    <Card style={styles.cardWrapper}>
      <CardHeader title="Login" />
      <CardContent>
        <form onSubmit={handleSubmit}>
          <TextField
            classes={{ root: 'text-field' }}
            fullWidth
            name="email"
            label="Email"
            required
            onChange={({ target }) => setUsername(target.value)}
          />
          <TextField
            classes={{ root: 'text-field' }}
            fullWidth
            name="password"
            label="Password"
            type="password"
            required
            onChange={({ target }) => setPassword(target.value)}
          />
          {displayError &&
            displayError.map((error) => (
              <div key={error} style={{ color: 'red' }}>
                {error}
              </div>
            ))}
          <div style={styles.buttonRow}>
            <Button
              color="primary"
              variant="text"
              style={styles.forgotButton}
              onClick={() => setForgotModalOpen(true)}
            >
              Forgot your password?
            </Button>
            <Button
              color="primary"
              variant="contained"
              style={styles.loginButton}
              onClick={() => window.location.href = "https://pennmedaccess.uphs.upenn.edu/saml/idp/ssov2/neuralert"}
              >
              Login with Penn
            </Button>
            <Button color="primary" variant="contained" type="submit" style={styles.loginButton}>
              Login
            </Button>
          </div>
        </form>
      </CardContent>
    </Card>
  </div>);
};

export default Login;